export default "__VITE_ASSET__Dv5fBVJZ__"